// extracted by mini-css-extract-plugin
module.exports = {"content":"legal_content__inXZN","paragraph":"legal_paragraph__XPfxc","title":"legal_title__e4EmV","text":"legal_text___smt_"};